import IconFA from '../../components/icon/icon';
import Button from '../../components/button/button';
import OfferCard from './offerCard';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function HPOffer() {
    return (
        <section className='offerContainer'>
            <motion.div
                style={{marginBottom: '50px'}}
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true, amount: 0.2 }}
            >
                <h2>Unsere Leistungen</h2>
                <p className='offerP'><IconFA iconName='arrowRight' fontSize='25px' color='#15283B' /> Verwalte Kunden mit Leichtigkeit</p>
                <p className='offerP'><IconFA iconName='arrowRight' fontSize='25px' color='#15283B' /> Effiziente Rechnungserstellung mit einfachen Tools</p>
                <p className='offerP'><IconFA iconName='arrowRight' fontSize='25px' color='#15283B' /> Angebote und Vorschläge leicht gemacht</p>
                <Link to='/register'><Button buttonType='Button' buttonValue='Jetzt loslegen!' /></Link>
            </motion.div>
            <motion.div 
                className='offerCardContainer'
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true, amount: 0.2 }}
            >
                <OfferCard index={0} offerCardTitle='Kundenmanagement vereinfacht' offerCardDescription='Yaccount bietet Kundenmanagement, Rechnungsstellung und Angebotsdienstleistungen effizient und effektiv für dein Unternehmen.' />
                <OfferCard index={1} offerCardTitle='Lösungen für Rechnungen' offerCardDescription='Erstelle und verwalte mühelos professionelle Rechnungen mit unseren benutzerfreundlichen Softwarelösungen und Dienstleistungen.' />
                <OfferCard index={2} offerCardTitle='Einfache Rechnungserstellung' offerCardDescription='Entdecke einfache Rechnungsstellungslösungen, die auf deine Geschäftsanforderungen und Wachstumschancen zugeschnitten sind.' />
                <OfferCard index={3} offerCardTitle='Einfache Vorschläge' offerCardDescription='Entdecke einfache Rechnungsstellungslösungen, die auf Ihre Geschäftsanforderungen und Wachstumschancen zugeschnitten sind.' />
            </motion.div>
        </section>
    );
}

export default HPOffer;